<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData"   ref="form" label-width="130px"
        v-loading="loading">
        <el-row :span="24">

          <el-col :span="12">
            <el-form-item prop="title" label="标题">
             {{ formData.title||'' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="amount" label="费用（元）">
           {{ formData.amount||'' }}

            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="expenseDate" label="费用发生日期">
             {{ formData.expenseDate||'' }}
            </el-form-item>

          </el-col>

        </el-row>
        <el-row :span="24">
          <el-col :span="24">

            <el-form-item prop="description" label="说明">
          {{ formData.description||'' }}
            </el-form-item>

          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'ExpenseManageDetail',

  data () {
    return {
      formData: {

        title: '',
        amount: undefined,
        description: '',
        expenseDate: '',
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.expenseId) {
      this.loadData()
    }
  },
  computed: {
    expenseId () {
      return this.$route.query.expenseId
    },

    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.expenseManage.selectPaExpenseRecordByExpenseId, {
          params: { expenseId: this.expenseId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }

}
.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
